module.exports = __webpack_public_path__ + "static/media/credit-card_amex.bb054f24.svg";